// Rejection wall. Shown when the account is signed in with Cognito but the server denied
// authorization for the command portal (wrong audience/role, off-domain, or MFA not satisfied). It
// deliberately replaces the authenticated shell — a signed-in-but-unauthorized user must never see
// the back-office chrome with every panel erroring. The only action is to sign out and try another
// account.
import { useNavigate } from "react-router-dom";
import { Btn, Surface, Brand } from "@championcare/ui";
import { useAppAuth } from "../auth";
import { STAFF_DOMAINS } from "../config";

export function NotAuthorized() {
  const { signOut, displayName } = useAppAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate("/sign-in", { replace: true });
  }

  return (
    <div className="signin">
      <Brand className="signin__brand" size={28} />
      <p className="signin__tag">Command — internal operations</p>
      <Surface className="signin__card">
        <h2 className="signin__heading">Not authorized</h2>
        <p className="signin__hint">
          {displayName ? <strong>{displayName}</strong> : "This account"} is signed in, but
          isn&rsquo;t authorized for the Command portal. Access is limited to ForceBase-verified staff
          ({STAFF_DOMAINS.join(", ")}). Sign in with an authorized account to continue.
        </p>
        <Btn as="button" variant="primary" onClick={handleSignOut}>
          Sign out
        </Btn>
      </Surface>
    </div>
  );
}
